import { FC } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import * as S from './styled';

const MenuProps = {
  disableScrollLock: true,
  PaperProps: {
    sx: {
      marginTop: '2px',
      borderRadius: '8px',
      boxShadow: '0px 20px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(0, 0, 0, 0.03)',
      maxHeight: '245px',
      overflowY: 'auto',
      '&::-webkit-scrollbar': { width: '4px' },
      '&::-webkit-scrollbar-thumb': {
        background: '#D8DBE8',
        borderRadius: '10px',
        transition: 'background 0.2s ease-in-out',
      },
      '&::-webkit-scrollbar-thumb:hover': { background: '#BFC3D4' },
      '&::-webkit-scrollbar-thumb:active': { background: '#A5AABF' },
    },
  },
  MenuListProps: {
    sx: {
      padding: '0px',
      borderRadius: '8px',
    },
  },
};

const Select: FC<any> = ({
  name,
  label,
  options,
  selectedValue,
  onChange,
  disabled = false,
  error = '',
  marginbottom = 16,
}) => {
  return (
    <div
      style={{
        marginBottom: marginbottom,
        pointerEvents: disabled ? 'none' : 'auto',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        width: '100%',
      }}
    >
      <S.SelectLabel error={error}>{label}</S.SelectLabel>
      <S.CustomSelect
        name={name}
        error={!!error}
        inputProps={{ 'aria-label': label }}
        fullWidth
        variant="outlined"
        label=""
        IconComponent={KeyboardArrowDownIcon}
        displayEmpty
        value={selectedValue?.id || ''}
        onChange={(e) => {
          const selectedOption = options.find((opt) => {
            return opt.id === Number(e.target.value);
          });
          onChange(selectedOption || null);
        }}
        renderValue={(selected: any) => {
          const selectedOption = options.find((opt) => {
            return opt.id === Number(selected);
          });
          return selectedOption?.name || 'Select...';
        }}
        MenuProps={MenuProps}
      >
        <S.CustomMenuItem value="" disabled>
          Select...
        </S.CustomMenuItem>
        {options.map((option: any) => {
          return (
            <S.CustomMenuItem key={option.id} value={option.id}>
              {option.name}
              {selectedValue?.id === option.id && (
                <S.Checkmark>
                  <CheckIcon />
                </S.Checkmark>
              )}
            </S.CustomMenuItem>
          );
        })}
      </S.CustomSelect>
      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}
    </div>
  );
};

export default Select;
